const getMonthTrueFormat = (a)=>{
    a++;
    if(a<10){
        // console.log('Дописываем нуль к ',a);
        a = '0'+a;
    }
    // console.log('теперь a вот такой = ',a);
    return a;
}

const getDateTrueFormat = (a)=>{
    if(a<10){
        a = '0'+a;
    }
    return a;
}

const getDateFormatUser = (date,typeDay,countDay = 0)=>{
    let dateStamp = date.getTime();
    let oneDaySecond = 24*3600*1000;
    let returnDay = dateStamp;

    switch (typeDay) {
        case "next": returnDay += oneDaySecond*countDay;break;
        case "back": returnDay -= oneDaySecond*countDay;break;
        default: returnDay += returnDay += oneDaySecond*countDay;
    }

    let returnDate = new Date(returnDay);
    // console.log(returnDate);

    let MonthResult = getMonthTrueFormat(returnDate.getMonth());

    // console.log('должны поставить с ведущим нулем, а получаем это = ',MonthResult);

    return (getDateTrueFormat(returnDate.getDate())+'.'+(MonthResult)+'.'+returnDate.getFullYear());
};

export default getDateFormatUser;